export default function CapsLockDetector(keyboardEvent){
    var charCode = false;
    if (keyboardEvent.which) {
        charCode = keyboardEvent.which;
    } else if (e.keyCode) {
        charCode = keyboardEvent.keyCode;
    }
    var shifton = false;
    if (keyboardEvent.shiftKey) {
        shifton = keyboardEvent.shiftKey;
    } else if (keyboardEvent.modifiers) {
        shifton = !!(keyboardEvent.modifiers & 4);
    }

    if ((charCode >= 97 && charCode <= 122 && shifton) ||
        (charCode >= 65 && charCode <= 90 && !shifton)) {
        return true;
    }
    return false;
}
